import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Pcl } from '../../index';
import { CacheTag } from '../../utils';

import type { Insurance, Transport } from '../../generated/pcl';
import type { Locale } from '@tuic/i18n';

export type ApiKitOfferData = {
  insurances?: Insurance[];
  transports?: Transport[];
};

/**
 * Fetches offer base data
 */
export const getOfferData = async (
  locale: Locale,
): Promise<ApiKitOfferData | null> => {
  const { data, error } = await Pcl.getOffer({
    query: { locale },
  });

  if (error) {
    logger.error(`Could not fetch offer data. Locale: ${locale}`);
    logger.error(error);

    return null;
  }

  if (typeof data === 'undefined') {
    return null;
  }

  return data;
};

/**
 * Fetches the port details for given portCode.
 */
export const cachedGetOfferData = (
  locale: Locale,
): Promise<ApiKitOfferData | null> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getOfferData', locale]),
    () => getOfferData(locale),
    {
      tags: [CacheTag.pcl, CacheTag.getOfferData],
      ttl: 600,
    },
  );
